function Autocomplete(theme: any): any {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '3px 9px'
          }
        },
        popupIndicator: {
          width: 'auto',
          height: 'auto'
        },
        popper: {
          border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.dark?.main : theme.palette.grey[100]}`
        },
        clearIndicator: {
          width: 'auto',
          height: 'auto'
        }
      }
    }
  };
}

export { Autocomplete };
